import { useField } from 'formik';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import { useViewerRoles } from '@treams/treams-hooks';
import { Button, Heading, Input, Separator, Subheading, Switch } from '@treams/treams-ui';

import EmployeesFilters from '../../packages/kakapo-ui-application/pages/employees/EmployeesFilters';
import HelpLink from '../../packages/kakapo-ui-kit/components/intercom/HelpLink';

function InboxManagerRecurseFilter() {
	const { t } = useTranslation();
	const [{ value }, , { setValue }] = useField('recurse');

	return (
		<Box mt={3}>
			<Switch
				label={t('managerInbox.options.recursive')}
				on={value}
				onChange={() => setValue(!value)}
			/>
		</Box>
	);
}

function InboxManagerOverdueFilter() {
	const { t } = useTranslation();
	const [{ value }, , { setValue }] = useField('onlyDue');

	return (
		<Box mt={3}>
			<Switch
				label={t('managerInbox.options.onlyDue')}
				on={value}
				onChange={() => setValue(!value)}
			/>
		</Box>
	);
}

export default function InboxManagerSidebar(props: { onExport: () => void }) {
	const { t } = useTranslation();

	const roles = useViewerRoles();

	const [{ value: startDate }, , { setValue: setStartDate }] = useField('startDate');
	const [{ value: endDate }, , { setValue: setEndDate }] = useField('endDate');

	return (
		<Box width={300}>
			<Flex mt={2}>
				<Box mt={3} mb={2} flexGrow={1} flexShrink={1}>
					<Heading>{t('managerInbox.options.title')}</Heading>
				</Box>
			</Flex>
			<Separator />
			{roles.isWorkspaceSuperuser && (
				<Box mt={2}>
					<HelpLink id="help.inbox.manager" />
				</Box>
			)}
			<Box my={4}>
				<Box mb={2}>
					<Subheading>{t('dashboard.sidebar.filters.timeframe.title')}</Subheading>
				</Box>
				<Flex mb={2}>
					<Box mr={2}>
						<Input.DatePicker value={startDate} onChange={(date) => date && setStartDate(date)} />
					</Box>
					<Input.DatePicker value={endDate} onChange={(date) => date && setEndDate(date)} />
				</Flex>
			</Box>
			<Box my={4}>
				<Separator />
			</Box>
			<EmployeesFilters status={roles.isWorkspaceSuperuser} />
			{!roles.isWorkspaceSuperuser && <InboxManagerRecurseFilter />}
			<InboxManagerOverdueFilter />
			<Box my={4}>
				<Separator />
			</Box>
			<Subheading>{t('managerInbox.options.export.title')}</Subheading>
			<Box mt={2} mb={3}>
				<Button
					small
					onClick={() => props.onExport()}
					title={t('managerInbox.options.export.button')}
				/>
			</Box>
		</Box>
	);
}
